import { Component, OnInit, ViewChild } from '@angular/core';
import { NgxSmartModalService, NgxSmartModalComponent } from 'ngx-smart-modal';
import { DatatableDefaultOptions } from '@app/DatatableDefaultOptions';
import { HttpClient } from '@angular/common/http';
import { DataTableDirective } from 'angular-datatables';
import { DataTablesRequest } from '@app/models/DataTablesRequest';
import { DataTablesResponse } from '@app/models/DataTablesResponse';
import { TimeTypeDataTableViewModel } from '@app/models/TimeTypeDataTableViewModel';
import { TimeTypeEditViewModel } from '@app/models/TimeTypeEditViewModel';

@Component({
    selector: 'app-time-types-datatable',
    templateUrl: './time-types-datatable.component.html',
    styleUrls: ['./time-types-datatable.component.css']
})
export class TimeTypesDatatableComponent implements OnInit {

    constructor(
        public ngxSmartModalService: NgxSmartModalService,
        private dataTableOptions: DatatableDefaultOptions,
        private http: HttpClient
    ) { }

    @ViewChild(DataTableDirective)
    private datatableElement: DataTableDirective;
    timeTypeDtOptions: DataTables.Settings = {};
    timeTypes: TimeTypeDataTableViewModel[]
    modalEdit: string = 'timeTypeEditModal'
    modalRemove: string = 'timeTypeRemoveModal'

    edit(timeType: TimeTypeDataTableViewModel): void {
        this.ngxSmartModalService.resetModalData(this.modalEdit)

        this.http.get<TimeTypeEditViewModel>("/api/timeType/update/" + timeType.id)
            .subscribe(data => {
                this.ngxSmartModalService.setModalData(data, this.modalEdit);
                this.ngxSmartModalService.open(this.modalEdit);
            });
    }

    remove(timeType: TimeTypeDataTableViewModel): void {
        this.ngxSmartModalService.setModalData(Number(timeType.id), this.modalRemove);
        this.ngxSmartModalService.open(this.modalRemove);
    }

    ngOnInit() {
        this.initDatatable()
    }

    ngAfterViewInit() {
        this.reloadDatatableOnModalCloseSuccess(this.modalEdit)
        this.reloadDatatableOnModalCloseSuccess(this.modalRemove)
    }

    initDatatable(): void {
        let self = this
        let lastDraw = 0
        this.timeTypeDtOptions = {
            ...this.dataTableOptions.defaults, ...{
                ajax: (dataTablesParameters: DataTablesRequest, callback: (data: DataTablesResponse) => any) => {
                    let request = JSON.stringify(dataTablesParameters)
                    self.http.get<DataTablesResponse>(`api/timeType/Datatable?request=${request}`).subscribe(response => {
                        if (response.draw < lastDraw) {
                            return;
                        }
                        lastDraw = response.draw
                        self.timeTypes = response.data;
                        let callbackResponse: DataTablesResponse = {
                            recordsTotal: response.recordsTotal,
                            recordsFiltered: response.recordsFiltered,
                            data: [],
                            draw: 0
                        }
                        callback(callbackResponse);
                    });
                },
            },
            columns: [
                { data: 'name' },
                { data: 'absence' },
            ]
        }
    }

    reloadDatatableOnModalCloseSuccess(modalName: string) {
        this.ngxSmartModalService.getModal(modalName).onClose.subscribe((modal: NgxSmartModalComponent) => {
            let data = modal.getData()
            if (data && data.success === true) {
                this.reloadDatatable()
            }
        });
    }

    reloadDatatable(): void {
        this.datatableElement.dtInstance.then((dtInstance: DataTables.Api) => dtInstance.ajax.reload());
    }

}
